import { render } from "./ClientSection.vue?vue&type=template&id=0971cb88"
import script from "./ClientSection.vue?vue&type=script&lang=js"
export * from "./ClientSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__